import { translateRich, useLocale } from "../../localization";
// ResponseQualityGauge.js
export default function ResponseQualityGauge({ assessments = [], detailed = false }) {
  useLocale();
  const categories = {
    detailed: assessments.filter((a) => (a.answer || "").length > 100).length,
    adequate: assessments.filter((a) => {
      const len = (a.answer || "").length;
      return len >= 50 && len <= 100;
    }).length,
    minimal: assessments.filter((a) => {
      const len = (a.answer || "").length;
      return len > 0 && len < 50;
    }).length,
    blank: assessments.filter((a) => !(a.answer || "").trim()).length,
  };

  const total = assessments.length || 1;

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ marginBottom: "20px" }}>
        {Object.entries(categories).map(([key, count]) => {
          const percentage = Math.round((count / total) * 100);
          return (
            <div key={key} style={{ marginBottom: "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "6px",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                <span style={{ textTransform: "capitalize" }}>{key}</span>
                <span>{percentage}%</span>
              </div>
              <div
                style={{
                  background: "rgba(0,0,0,0.06)",
                  borderRadius: "8px",
                  height: "8px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    background: "rgba(139, 92, 246, 0.7)",
                    width: `${percentage}%`,
                    height: "100%",
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {detailed && (
        <div
          style={{
            fontSize: "12px",
            color: "rgba(0,0,0,0.5)",
            marginTop: "16px",
            paddingTop: "16px",
            borderTop: "1px solid rgba(0,0,0,0.08)",
          }}
        >{translateRich("Total responses analyzed: {value0}", {
  value0: assessments.length
})}</div>
      )}
    </div>
  );
}
